// extracted by mini-css-extract-plugin
export default {"scrollBar":"scrollbar_scrollBar__rTbjC","frameScrollBar":"scrollbar_frameScrollBar__06jz+","scrollHandle":"scrollbar_scrollHandle__sKslY","scrollBarV":"scrollbar_scrollBarV__Og1vV"};